import React, { createContext, useState } from "react";
import {getCurrentOrganization} from '@/utils/functions/OrganizationFunctions';

export const OrganizationContext = createContext<any | undefined>(undefined);

export const OrganizationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [organization, setOrganization] = useState<any>(getCurrentOrganization());
  return (
    <OrganizationContext.Provider value={{ organization, setOrganization }}>
      {children}
    </OrganizationContext.Provider>
  );
};